import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgCheckIn = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M12 2h-1.55a2.501 2.501 0 0 0-4.9 0H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2M4.5 3.5v.75c0 .416.334.75.75.75h5.5c.416 0 .75-.334.75-.75V3.5h.5c.275 0 .5.225.5.5v10c0 .275-.225.5-.5.5H4a.5.5 0 0 1-.5-.5V4c0-.275.225-.5.5-.5zm2.75-1a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m3.781 5.863a.75.75 0 0 0-1.06-1.06L7.17 10.106 6.03 8.97a.75.75 0 0 0-1.06 1.06l1.667 1.665a.75.75 0 0 0 .53.218c.2 0 .391-.078.532-.218z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCheckIn);
export default ForwardRef;
